<ng-container *ngIf="!loading else loadingMask">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <div class="row d-flex flex-column mx-0 pt-2">
          <div class="col pt-2 d-flex">
            <span class="col-md-2 col-sm-4 text-muted font-weight-bold">Submitted On:</span>
            <span class="col-md-10 col-sm-8">{{ waybillDetail?.stored | date:'MM/dd/yyyy h:mm:ss a' }}</span>
          </div>
          <div class="col pt-2 d-flex">
            <span class="col-md-2 col-sm-4 text-muted font-weight-bold">Updated On:</span>
            <span class="col-md-10 col-sm-8">{{ waybillDetail?.updated | date:'MM/dd/yyyy h:mm:ss a' }}</span>
          </div>
          <div class="col pt-2 d-flex">
            <span class="col-md-2 col-sm-4 text-muted font-weight-bold">User Id:</span>
            <span class="col-md-10 col-sm-8">{{ waybillDetail?.userId }}</span>
          </div>
          <div class="col pt-2 d-flex">
            <span class="col-md-2 col-sm-4 text-muted font-weight-bold">Name:</span>
            <span class="col-md-10 col-sm-8">{{ waybillDetail?.userName }}</span>
          </div>
          <div class="col pt-2 d-flex">
            <span class="col-md-2 col-sm-4 text-muted font-weight-bold">Waybill Serial Number:</span>
            <span class="col-md-10 col-sm-8">{{ waybillSerial }}</span>
          </div>
          <div class="col pt-2 d-flex">
            <span class="col-md-2 col-sm-4 text-muted font-weight-bold">Request Number:</span>
            <span class="col-md-10 col-sm-8">{{ requestNumber }}</span>
          </div>
          <div class="col pt-2 d-flex">
            <span class="col-md-2 col-sm-4 text-muted font-weight-bold">Current Status:</span>
            <span class="col-md-10 col-sm-8">{{ waybillDetail?.status }}</span>
          </div>
          <div class="col pt-2 d-flex">
            <div class="p-3">
              <ng-diversions-review-form [type]="waybillType"
                                         [form]="form">
              </ng-diversions-review-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <section class="d-flex justify-content-center py-3 fixed-bottom bg-white"
           *ngIf="!status?.includes('Cancelled') && !status?.includes('Completed') && !status?.includes('Rejected')">
    <button mat-flat-button color="accent" class="mr-4" aria-label="Cancel request" [disabled]="loading"
            (click)="confirmBeforeActionDialog('Cancel')">
    <span class="d-flex flex-row">
      <ng-container *ngIf="loading">
        <div class="mr-2">Canceling...</div>
        <mat-spinner class="align-self-center" color="accent" diameter="20"></mat-spinner>
      </ng-container>
      <span *ngIf="!loading">Cancel This Request</span>
    </span>
    </button>
    <button mat-flat-button color="accent" class="mr-4" aria-label="Reject request" [disabled]="loading"
            (click)="confirmBeforeActionDialog('Reject')" *ngIf="waybillType?.includes('Reship')">
    <span class="d-flex flex-row">
      <ng-container *ngIf="loading">
        <div class="mr-2">Rejecting...</div>
        <mat-spinner class="align-self-center" color="accent" diameter="20"></mat-spinner>
      </ng-container>
      <span *ngIf="!loading">Reject This Request</span>
    </span>
    </button>
    <button mat-flat-button color="accent" class="mr-4" aria-label="Complete request" [disabled]="loading"
            (click)="confirmBeforeActionDialog('Complete')" *ngIf="waybillType?.includes('Reship')">
    <span class="d-flex flex-row">
      <ng-container *ngIf="loading">
        <div class="mr-2">Completing...</div>
        <mat-spinner class="align-self-center" color="accent" diameter="20"></mat-spinner>
      </ng-container>
      <span *ngIf="!loading">Complete This Request</span>
    </span>
    </button>
  </section>
</ng-container>

<ng-template #loadingMask>
  <ns-skeleton [type]="skeleton"></ns-skeleton>
</ng-template>
